import FormPaymentLot from './form-payment-lot';
export default FormPaymentLot;